export let BreakpointQueryName = /*#__PURE__*/function (BreakpointQueryName) {
  BreakpointQueryName["XS"] = "XS";
  BreakpointQueryName["SM"] = "SM";
  BreakpointQueryName["MD"] = "MD";
  BreakpointQueryName["LG"] = "LG";
  BreakpointQueryName["XL"] = "XL";
  return BreakpointQueryName;
}({});
const BREAKPOINTS_QUERY = {
  [BreakpointQueryName.XS]: '0px',
  [BreakpointQueryName.SM]: '576px',
  [BreakpointQueryName.MD]: '768px',
  [BreakpointQueryName.LG]: '992px',
  [BreakpointQueryName.XL]: '1200px'
};
export default BREAKPOINTS_QUERY;
//# sourceMappingURL=breakpoints.js.map